import posthog from 'posthog-js'

// Initialize PostHog only on the client side
if (typeof window !== 'undefined') {
  const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY
  const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST

  if (!posthogKey || !posthogHost) {
    console.warn('[PostHog] Missing environment variables. PostHog will not be initialized.')
  } else {
    posthog.init(posthogKey, {
      api_host: posthogHost,

      // Person Profiles: Use 'always' to capture all users including anonymous visitors
      // This enables session recordings for all users, not just logged-in ones
      person_profiles: 'always',

      // Page tracking: Disable automatic pageview capture for manual control
      // We'll manually capture pageviews in the PostHogProvider component
      capture_pageview: false,
      capture_pageleave: true,

      // Session Recording Configuration - SECURE
      session_recording: {
        maskAllInputs: true, // MASK all input fields (passwords, emails, etc.)
        maskTextSelector: undefined, // Don't mask regular text on page
        recordCrossOriginIframes: false, // Don't record cross-origin iframes
      },

      // Autocapture Configuration
      autocapture: {
        // Capture common events
        dom_event_allowlist: ['click', 'submit', 'change'],

        // No CSS selector restrictions
        css_selector_allowlist: undefined,

        // No URL restrictions
        url_allowlist: undefined,
      },

      // Privacy: Don't mask regular text, but inputs are masked above
      mask_all_text: false,

      // Debug mode (only in development)
      debug: process.env.NODE_ENV === 'development',

      // Persistence: Use localStorage (default)
      persistence: 'localStorage',

      // Exception autocapture: automatically capture unhandled errors
      autocapture_exceptions: true,

      // Callback when PostHog is loaded
      loaded: () => {
        if (process.env.NODE_ENV === 'development') {
          console.log('[PostHog] Successfully initialized')
        }
      },
    })
  }
}

export default posthog
